<div class="powerBi" style=" width: 100%;height: 720px; border: none;" #reportContainer></div>
